const modelName = 'dailyrate';

export default {
	model: modelName,
	elements: [
		{
			field: 'effectiveDate'
		},
		{
			field: 'gold18'
		},
		{
			field: 'gold21'
		},
		{
			field: 'gold24'
		},
		{
			field: 'jewelry'
		}
	]
};
